import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/styles/reset.css'
import './assets/styles/common.css'
import './plugins/element.js'
import './plugins/vcharts.js'
import plugins from '@/plugins/plugins'
import version from '@/static/version'
Vue.use(version)

// import VueSrollTo from 'vue-scrollto'
// Vue.use(VueSrollTo)


Vue.use(plugins)

import 'swiper/dist/css/swiper.css'
import '@/assets/icons/iconfont.css'
import '@/assets/global.css'
import '@/api/request'

//import '@/mock/mockServer'
import request from "@/api/request";
//import VueNumberFormat from 'vue-number-format'

//Vue.use(VueNumberFormat, {prefix: '$', thousand: ',', precision: 0})

// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

Vue.prototype.request = request
Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
